/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, themeV2} from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- NEW REPORT PAGE : STYLES --------------- ++++++++++ */
export default theme => ({
    newReport: {
      '& .content': { marginBottom: pxToEm(16) },
      '& .newreport-true': {
        '&#content': { 
          display: 'flex',
          height: '100%',
          flexDirection: 'column',
          '& .pagecontent': {
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }
        }
      },
    },

    wrapper: {
        width: '100%',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'transparent'
    },
    cardWrapper: {
        maxWidth: pxToEm(1280),
        borderRadius: pxToEm(4),
        marginBottom: pxToEm(16),
        backgroundColor: themeV2.color.base.white,
        '& .sectiongroup': {
            flex: 1
        }
    },
    createNewMessageBox: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        '& p': {
            maxWidth: pxToEm(700),
            textAlign: 'center',
            marginBottom: pxToEm(50)
        }
    }
});
